import Box from '@/common/components/Box'
import Button from '@/common/components/Button'
import { useCreateForwardingsFormStore } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/stores/createForwardingsFormStore'

interface CreateForwardingDirectiveEntryFormStepCompletedProps {
  stepIndex: number
  title: string
  body: JSX.Element | null
}

const CreateForwardingDirectiveEntryFormStepCompleted = ({
  stepIndex,
  title,
  body,
}: CreateForwardingDirectiveEntryFormStepCompletedProps) => {
  const { setCurrentStep } = useCreateForwardingsFormStore()

  return (
    <Box className="p-4 bg-success-op flex flex-col gap-2 w-full">
      <div className="flex items-center justify-between">
        <p>{title}</p>

        <Button variant="error" onClick={() => setCurrentStep(stepIndex)}>
          Voltar para essa seleção
        </Button>
      </div>

      <div>{body}</div>
    </Box>
  )
}

export default CreateForwardingDirectiveEntryFormStepCompleted
